import type {Me} from "@/src/modules/core/types";
import type {GpsSource} from "@/src/modules/core/types/geolocation";
import type {Shift} from "@/src/modules/shifts/types";

import type {VehicleCheckCreatePayload} from "../types";
import {shouldSendShiftIdOnVehicleCheckCreate} from "./vehicle-check-create-policy";

type GpsFields = {
  gps_coordinates?: string;
  gps_source?: GpsSource;
};

function withOptionalShiftId(
  me: Me | null | undefined,
  shift: Shift | null | undefined,
  payload: VehicleCheckCreatePayload,
): VehicleCheckCreatePayload {
  if (!shouldSendShiftIdOnVehicleCheckCreate(me) || !shift?.shift_id) {
    return payload;
  }
  return {...payload, shift_id: shift.shift_id};
}

export function buildPhotoVehicleCheckCreatePayload(
  me: Me | null | undefined,
  input: {
    property_id: number;
    files: [string];
    shift?: Shift | null;
    gps_coordinates?: string;
    gps_source?: GpsSource;
  },
): VehicleCheckCreatePayload {
  const payload: VehicleCheckCreatePayload = {
    property_id: input.property_id,
    files: input.files,
    ...(input.gps_coordinates ? {gps_coordinates: input.gps_coordinates} : {}),
    ...(input.gps_source ? {gps_source: input.gps_source} : {}),
  };
  return withOptionalShiftId(me, input.shift ?? null, payload);
}

export function buildSkipAiVehicleCheckCreatePayload(
  me: Me | null | undefined,
  input: {
    vehicle_id: number;
    shift?: Shift | null;
    gps_coordinates?: string;
    gps_source?: GpsSource;
  },
): VehicleCheckCreatePayload {
  const payload: VehicleCheckCreatePayload = {
    vehicle_id: input.vehicle_id,
    ...(input.gps_coordinates ? {gps_coordinates: input.gps_coordinates} : {}),
    ...(input.gps_source ? {gps_source: input.gps_source} : {}),
  };
  return withOptionalShiftId(me, input.shift ?? null, payload);
}
